export default function IconCopyPaste({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M15.1875 6.18652V3.93652C15.1875 3.63815 15.069 3.35201 14.858 3.14103C14.647 2.93005 14.3609 2.81152 14.0625 2.81152H11.0625"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.6875 2.81152H1.6875C1.38913 2.81152 1.10298 2.93005 0.892005 3.14103C0.681026 3.35201 0.5625 3.63815 0.5625 3.93652V16.3115C0.5625 16.6099 0.681026 16.896 0.892005 17.107C1.10298 17.318 1.38913 17.4365 1.6875 17.4365H6.1875"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8159 3.55178C10.7785 3.6638 10.7068 3.76122 10.6109 3.83026C10.5151 3.89931 10.4 3.93648 10.2819 3.93653H5.46839C5.35028 3.93648 5.23517 3.89931 5.13934 3.83026C5.04352 3.76122 4.97182 3.6638 4.93439 3.55178L4.18439 1.30178C4.15604 1.2172 4.14825 1.12708 4.16165 1.03889C4.17505 0.950702 4.20926 0.86697 4.26144 0.794627C4.31363 0.722283 4.38229 0.663408 4.46175 0.622873C4.54122 0.582338 4.62919 0.561308 4.71839 0.561525H11.0319C11.1211 0.561308 11.2091 0.582338 11.2885 0.622873C11.368 0.663408 11.4366 0.722283 11.4888 0.794627C11.541 0.86697 11.5752 0.950702 11.5886 1.03889C11.602 1.12708 11.5942 1.2172 11.5659 1.30178L10.8159 3.55178Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.4375 8.43652H17.4375V17.4365H8.4375V8.43652Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6875 10.6865H15.1875"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6875 12.9365H15.1875"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6875 15.1865H12.375"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
